import { Component, OnInit } from '@angular/core';
import { OnboardingService } from '../../../../shared/services/onboarding.service';
import { ActivatedRoute, Router } from '@angular/router';
import { KycService } from '../../../../shared/services/kyc.service';
import { ToastrService } from 'ngx-toastr';
import { FundingService } from '../../../../shared/services/funding.service';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-flow-menu',
  templateUrl: './flow-menu.component.html',
  styleUrls: ['./flow-menu.component.scss']
})
export class FlowMenuComponent implements OnInit {
  verified: boolean = false;
  responses: boolean;
  userSuitability: boolean = false;

  vwallet: any;
  fund: any;
  firstname: string;
  lastname: string;
  userDetails: boolean = false;
  error: boolean = false;
  errMsg: string;

  constructor(private api: OnboardingService,
    private route: ActivatedRoute,
    private router: Router,
    private kyc: KycService,
    private SpinnerService: NgxSpinnerService,
    private wallet: FundingService,
    private toastr: ToastrService) { }

  ngOnInit() {
    // this.check();
    this.Profile()
  }

  // check() {
  //   this.api.getResponse().subscribe((res: any) => {
  //     this.response = res.data.length;

  //     if (this.response == 0)
  //       return this.userSuitability = true;
  //     else
  //     return this.userSuitability = false;
  //   },err=>{
  //     this.error = true;
  //   })

  // }

  Profile() {
    this.SpinnerService.show();
    this.kyc.getProfile()
      .subscribe((res: any) => {

        this.firstname = res.data.firstName;
        this.lastname = res.data.lastName;
        localStorage.setItem('userId',res.data.userId);
        if (this.firstname != null && this.lastname != null) {
          this.userDetails = true;
        }

        if(res.data.portfolioType === null){
          console.log(res.data.portfolioType,this.userSuitability,'jj')
          this.userSuitability = false;
          console.log(this.userSuitability,'jjs')

        }
        else{
          console.log(this.userSuitability,'jjsb')
          this.userSuitability = true;
        }
        
        console.log(this.userSuitability,'out')

        this.getWallet();

        if (res.data.userKyc[1].status == 'VERIFIED') {
          this.verified = true

          //redirect to dashboard if user has completed onboarding process
          if (this.verified == true && this.userSuitability == true) {
            console.log(this.verified, this.userSuitability, 'nn')
            this.router.navigate(['/dashboard/portfolio'])
          }
          else
            this.router.navigate(['/onboarding/menu'])

        }
        if (res.data.userKyc[1].status == 'PENDING')
          this.verified = false;
        this.SpinnerService.hide();
      }, err => {
        this.SpinnerService.hide()
        this.verified = false;
      })
  }

  //getWalletTransactions
  getWallet() {
    this.kyc.getUserWalletTransaction()
      .subscribe((res: any) => {

        if (res.count != 0) {
          this.vwallet = res.data[0].amount;

          if (this.vwallet != 0 && this.vwallet != undefined) {
            this.fund = true;
          }
          else {
            this.fund = false;
          }
        }
        else {
          this.fund = false;
        }

      }, err => {
        this.error = true;
      })
  }

}
